import { OverlayConfig } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';
import { Column, TemplatesRefMap } from '@miq/catalog';
import { DataObject } from '@shared/models/data-object.model';
import { CumulativeBoxStore } from './cumulative-box/cumulative-box.service';

export const EDITING_BOX_SECTIONS = new InjectionToken<any[]>('EDITING_BOX_SECTIONS');
export const EDITING_BOX_RECORDS = new InjectionToken<any[]>('EDITING_BOX_RECORDS');

export interface EditingBoxConfigItem {
  updatableFields?: string[] | ((record: any) => string[]);
  labelMode?: 'associated' | 'normal';
  columns?: Column[];
}

export class EditingBoxOverlayConfig extends OverlayConfig {
  record: DataObject;
  sections: EditingBoxConfigItem[];
  constructor(config: OverlayConfig, record: DataObject, sections: EditingBoxConfigItem[]) {
    super(config);
    this.record = record;
    this.sections = sections;
  }
}

export const CUMULATIVE_BOX_STORE = new InjectionToken<CumulativeBoxStore>('CumulativeBoxStore');
export const CUMULATIVE_BOX_CONTROL = new InjectionToken<{ close: (data) => void }>(
  'CUMULATIVE_BOX_CUMULATIVE_COLUMNS'
);

export interface CumulativeBoxOverlayData {
  record: DataObject;
  totalColumn: Column;
  cumulativeColumns: Column[];
  autoSum?: boolean;
  showAutoSumControl?: boolean;
  isNewRecord: boolean;
  customTemplateRefMap?: TemplatesRefMap;
}
